import { Component, createRef } from "react";
import {
  Grid,
  IconButton,
  TextField,
  Tooltip,
  Typography,
} from "@mui/material";
import PropTypes from "prop-types";

import ProgressCirc from "src/components/layout/Progress/ProgressCirc";
import StepButtons from "src/components/buttons/StepButtons/StepButtons";
import { EditIcon, SaveIcon } from "src/components/icons/ActionIcons";
import {
  cache_clear,
  cache_read,
  cache_write,
  helps_cacheName,
} from "src/components/js/CacheFunctions";

export default class InfoBox extends Component {
  constructor(props) {
    super(props);
    this.otsikkoRef = createRef();
    this.htmlTextRef = createRef();
    this.state = {
      items: [],
      title: "haetaan...",
      text: "",
      rev: 0,
      isLoaded: false,
    };
  }
  componentDidMount() {
    try {
      this.getData();
    } catch (error) {
      console.log(error);
    }
  }

  getData() {
    const url =
      import.meta.env.VITE_SERVER_URL + "/api/helps/get/" + this.props.helpId;
    try {
      const c = cache_read(helps_cacheName, url);
      if (c) {
        this.processJson(c);
        return;
      }

      fetch(url)
        .then((res) => res.json())
        .then((json) => {
          cache_write(helps_cacheName, url, json, 3600);
          this.processJson(json);
        })
        .catch((error) => {
          throw error;
        });
    } catch (error) {
      console.log(error);
    }
  }

  processJson(json) {
    if (json.length > 0)
      this.setState({
        title: json[0].title,
        htmlText: json[0].htmltext,
        img: json[0].img,
        rev: json[0].rev,
        shortText: json[0].shorttext,
      });
    else
      this.setState({
        title: "Syötä otsikko",
      });

    this.setState({
      isLoaded: true,
      editOtsikko: false,
      editText: false,
    });
    this.props.onShowSuljeButtonChange(true);
  }

  render() {
    const allowEdit = this.props.allowEdit;
    const onEditTitleButtonClick = (value) => {
      this.setState({ editOtsikko: value });
      this.props.onShowSuljeButtonChange(false);
    };
    const onEditHtmlTextButtonClick = (value) => {
      this.setState({ editText: value });
      this.props.onShowSuljeButtonChange(false);
    };
    const onSaveTitleButtonClick = () => {
      cache_clear(helps_cacheName);
      const otsikko = this.otsikkoRef.current.value;
      this.setState({
        title: otsikko,
        editOtsikko: false,
      });
      this.props.onShowSuljeButtonChange(true);
      const requestOptions = {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          helpId: this.props.helpId,
          img: this.state.img,
          title: otsikko,
          shorttext: this.state.shortText,
          htmltext: this.state.htmlText,
        }),
      };
      fetch(
        import.meta.env.VITE_SERVER_URL + "/api/helps/update",
        requestOptions
      ).then((response) => response.json());
    };
    const onSaveHtmlTextButtonClick = () => {
      cache_clear(helps_cacheName);
      const htmlTeksti = this.htmlTextRef.current.value;
      this.setState({
        htmlText: htmlTeksti,
        editText: false,
      });
      this.props.onShowSuljeButtonChange(true);
      const requestOptions = {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          helpId: this.props.helpId,
          img: this.state.img,
          title: this.state.title,
          shorttext: this.state.shortText,
          htmltext: htmlTeksti,
        }),
      };
      fetch(
        import.meta.env.VITE_SERVER_URL + "/api/helps/update",
        requestOptions
      ).then((response) => response.json());
    };

    return (
      <>
        <Grid container sx={{ width: "100%" }}>
          <Grid size={{ xs: 11 }}>
            {!this.state.editOtsikko ? (
              <>
                {this.state.isLoaded ? (
                  <Typography
                    //className={classes.div2}
                    id="helperOtsikko"
                    variant="h6"
                    color="primary"
                    component="span"
                    sx={{ whiteSpace: "pre-line" }}
                    dangerouslySetInnerHTML={{ __html: this.state.title }}
                  ></Typography>
                ) : (
                  <ProgressCirc isLoading={!this.state.isLoaded} />
                )}
              </>
            ) : (
              <>
                <TextField
                  fullWidth
                  id="editOtsikkoTxt"
                  label="Otsikko"
                  defaultValue={this.state.title}
                  inputRef={this.otsikkoRef}
                  onKeyDown={(e) => {
                    if (e.key === "Enter") {
                      onSaveTitleButtonClick();
                    }
                    if (e.key === "Escape") {
                      this.getData();
                    }
                  }}
                />
              </>
            )}
          </Grid>
          <Grid size={{ xs: 1 }}>
            {allowEdit ? (
              <div className="noPrint">
                {!this.state.editOtsikko ? (
                  <IconButton
                    onClick={() =>
                      onEditTitleButtonClick(!this.state.editOtsikko)
                    }
                    aria-label="Muokkaa"
                  >
                    <EditIcon />
                  </IconButton>
                ) : (
                  <IconButton
                    onClick={() => onSaveTitleButtonClick()}
                    aria-label="Tallenna"
                  >
                    <SaveIcon />
                  </IconButton>
                )}
              </div>
            ) : (
              ""
            )}
          </Grid>
        </Grid>
        <Grid container sx={{ width: "100%" }}>
          <Grid size={{ xs: 11 }}>
            {!this.state.editText ? (
              <>
                <Typography color="primary" component="div">
                  <span
                    style={{ whiteSpace: "pre-line" }}
                    dangerouslySetInnerHTML={{ __html: this.state.htmlText }}
                  />
                </Typography>
              </>
            ) : (
              <TextField
                fullWidth
                id="editSeliteTxt"
                label="Selite"
                multiline
                maxRows={8}
                defaultValue={this.state.htmlText}
                inputRef={this.htmlTextRef}
              />
            )}
          </Grid>
          <Grid size={{ xs: 1 }}>
            {allowEdit ? (
              <>
                {!this.state.editText ? (
                  <Tooltip title={this.props.helpId} disableInteractive>
                    <IconButton
                      onClick={() =>
                        onEditHtmlTextButtonClick(!this.state.editText)
                      }
                      aria-label="Muokkaa"
                    >
                      <EditIcon color="primary" />
                    </IconButton>
                  </Tooltip>
                ) : (
                  <IconButton
                    onClick={() => onSaveHtmlTextButtonClick()}
                    aria-label="Tallenna"
                  >
                    <SaveIcon />
                  </IconButton>
                )}
              </>
            ) : (
              ""
            )}
          </Grid>
        </Grid>
        {(this.state.editOtsikko || this.state.editText) && (
          <>
            <StepButtons
              onCancelKlik={() => this.getData()}
              onSaveKlik={() => {
                if (this.state.editText) onSaveHtmlTextButtonClick();
                if (this.state.editOtsikko) onSaveTitleButtonClick();
              }}
            />
          </>
        )}
      </>
    );
  }
}

InfoBox.propTypes = {
  allowEdit: PropTypes.bool,
  onShowSuljeButtonChange: PropTypes.func,
  helpId: PropTypes.string,
};
